import React from "react"
import classes from "./Layout.module.css"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSun } from "@fortawesome/free-solid-svg-icons"
import { faMoon } from "@fortawesome/free-regular-svg-icons"
import FlioSync from "../Usersettings/FlioSync/FlioSync"

const Layout = props => {
    const { t } = useTranslation()

    return (
        <>
            <header>
                <h1 style={{ textAlign: "center" }}>Game Version 10.0.0</h1>
                <nav className={classes.Nav}>
                    <ul>
                        <li>
                            <NavLink to="/" end className={({ isActive }) => (isActive ? classes.Active : classes.Link)}>
                                {t("misc:Navigation.GearSeedChecker")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/seedrecover" end className={({ isActive }) => (isActive ? classes.Active : classes.Link)}>
                                {t("misc:Navigation.GearSeedRecovery")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/seedlisting" end className={({ isActive }) => (isActive ? classes.Active : classes.Link)}>
                                {t("misc:Navigation.SeedListing")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/database" end className={({ isActive }) => (isActive ? classes.Active : classes.Link)}>
                                {t("misc:Navigation.GearDatabase")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/tutorial" end className={({ isActive }) => (isActive ? classes.Active : classes.Link)}>
                                {t("misc:Navigation.Tutorial")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/writeup" end className={({ isActive }) => (isActive ? classes.Active : classes.Link)}>
                                {t("misc:Navigation.TechnicalDetails")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/settings" end className={({ isActive }) => (isActive ? classes.Active : classes.Link)}>
                                {t("other:Cmn_OptionTop.L_UserSetting-T_Text")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/profile" end className={({ isActive }) => (isActive ? classes.Active : classes.Link)}>
                                Profile
                            </NavLink>
                        </li>
                        <li>
                            {props.lightTheme ? (
                                <FontAwesomeIcon icon={faMoon} onClick={props.onSwitch} />
                            ) : (
                                <FontAwesomeIcon icon={faSun} onClick={props.onSwitch} />
                            )}
                        </li>
                        <li>
                            <FlioSync />
                        </li>
                    </ul>
                </nav>
            </header>
            <main className={classes.Content}>{props.children}</main>
        </>
    )
}

export default Layout
